import { reservationFormSchema } from '../../schema/reservationForm.schema';

import { getAggregatedFormValues } from '../../utils/getAggregatedFormValues';
import type { ReservationFormMainContext } from '../reservationFormMain.types';

export function canSubmitFromContext(
  context: ReservationFormMainContext,
): boolean {
  const aggregated = getAggregatedFormValues(context);
  const parsed = reservationFormSchema.safeParse(aggregated);
  return parsed.success;
}
